const dropzone = "_35sd1m8dc20";
const placeholder = "_35sp173y2x6";
const dropzoneChildren = "_35sdazk5fi";

export { dropzone, dropzoneChildren, placeholder };
import "./atom.target.style.linaria.module.css";
//# sourceMappingURL=atom.target.style.js.map
